import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { FC, useId } from 'react';

import { useDateItem } from '~/components/ModalSlotsSelectDate/hooks';

import { checkoutStore } from '~/stores';

import styles from './DateItem.module.scss';

interface DateItemProps {
  timeStamp: string;
  isDisabled: boolean;
  isChecked: boolean;
  onChange: (value: string) => void;
}

const DateItem: FC<DateItemProps> = ({
  timeStamp,
  isDisabled,
  isChecked,
  onChange,
}) => {
  const inputId = useId();
  const { day } = useDateItem({ timeStamp });

  const order = checkoutStore.slotSelectionModalStore.selectedOrder;

  if (!order) {
    throw new Error('Order not found');
  }

  return (
    <li className={styles.slotDate}>
      <input
        data-radio="date"
        type="radio"
        value={timeStamp}
        id={inputId}
        name="date"
        checked={isChecked}
        onChange={({ target }) => {
          onChange(target.value);
        }}
        disabled={isDisabled}
      />
      <label
        htmlFor={inputId}
        className={classes([styles.slotDateLabel, isChecked && styles.checked])}
      >
        {day}
      </label>
    </li>
  );
};

export default observer(DateItem);
